<template>
    <main class="a-market a-main" id="a-market">
        <div class="a-main__container">
            <div class="a-main__title a-market__title">
                {{ title }}
            </div>
            <div class="a-market__component" id="research">
                <loader v-if="researchIsLoading" />
                <error v-if="researchError" />
                <research-no-multipage
                    v-if="research"
                    :desktop-small-device="desktopSmallDevice"
                    :desktop-device="desktopDevice"
                    :tablet-device="tabletDevice"
                    :mobile-device="mobileDevice"
                    :research-data-items="research"
                    :research-data="researchData"
                    @option-selected="optionSelected"
                    @date-selected="dateSelected"
                    @onhide="onHideMoreContent('#research')"
                />
            </div>
            <overview
                :overview-data="overviewData"
                :json-overview-data="jsonObzorRynka" />
            <div class="a-market__component" id="digest">
                <loader v-if="reportListIsLoading" />
                <error v-if="reportListError" />
                <research-no-multipage v-if="reportList"
                    :desktop-small-device="desktopSmallDevice"
                    :desktop-device="desktopDevice"
                     :tablet-device="tabletDevice"
                    :mobile-device="mobileDevice"
                    :research-data-items="reportList"
                    :research-data="digestData"
                    @option-selected="reportListOptionSelected"
                    @date-selected="reportListDateSelected"
                    @onhide="onHideMoreContent('#digest')"
                />
            </div>
            <div class="a-market__component" id="review">
                <loader v-if="reviewListIsLoading" />
                <error v-if="reviewListError" />
                <research-no-multipage
                    v-if="reviewList"
                    :desktop-small-device="desktopSmallDevice"
                    :desktop-device="desktopDevice"
                    :tablet-device="tabletDevice"
                    :mobile-device="mobileDevice"
                    :research-data-items="reviewList"
                    :research-data="reviewData"
                    @option-selected="reviewListOptionSelected"
                    @date-selected="reviewListDateSelected"
                    @onhide="onHideMoreContent('#review')"
                />
            </div>
            <div class="a-market__component">
                <loader v-if="pressReleaseIsLoading" />
                <error v-if="pressReleaseError" />
                <news
                    v-if="pressRelease"
                    :news-data="newsData"
                    :news-data-items="pressRelease"
                />
            </div>
        </div>
    </main>
</template>

<script>
    import Loader from '../Loader'
    import Error from '../Error' 
    import ResearchNoMultipage from '../ResearchNoMultipage.vue';
    import Overview from '../Overview'
    import News from '../News'
    import headerSearchHandler from '../../modules/a-main-nav'
    import {pressReleaseActionTypes} from '../../store/modules/press-release'
    import {researchActionTypes} from '../../store/modules/research'
    import {reportListActionTypes} from '../../store/modules/report'
    import {reviewListActionTypes} from '../../store/modules/review'
    import {mapState} from 'vuex'
    import scrollToElement from '../../helpers/scrollToElement';

    export default {
        name: 'Market',
        components: {
            ResearchNoMultipage,
            Overview,
            News,
            Error,
            Loader
        },
        data() {
            return {
                title: 'Интересное по рынку',
                apiPressRelease: '/api/v2/content/analytics/press-release/',
                apiResearch: '/api/v2/content/analytics/list/',
                dateFrom: '',
                dateTo: '',
                pageParams: '',
                reportListDateFrom: '',
                reportListDateTo: '',
                reviewListDateFrom: '',
                reviewListDateTo: '',
                jsonObzorRynka: null,
                researchData: {
                    link: {
                        href: '/analytics/archive/?section=850',
                        title: 'Архив исследований',
                    },
                },
                digestData: {
                    title: 'Еженедельный дайджест Аналитического центра ДОМ.РФ',
                    link: {
                        href: '/analytics/archive/?section=949',
                        title: 'Архив исследований',
                    },
                    addClass: '_digest',
                    disableDescription: true
                },
                reviewData: {
                  title: 'Обзоры рынка аренды жилья'
                },
                overviewData: {
                    imageData: {
                        src: '/static/v2/src/img/analytics/construction/overview',
                        alt: 'Рынок жилья',
                        width: '935',
                        height: '583'
                    },
                },
                newsData: {
                    title: 'Пресс-релизы',
                    button: {
                        text: 'Все пресс-релизы',
                        href: '/analytics/analytical-center/'
                    },
                },
            }
        },
        computed: {
            ...mapState({
                pressReleaseIsLoading: state => state.pressRelease.isLoading,
                pressRelease: state => state.pressRelease.data,
                pressReleaseError: state => state.pressRelease.error,
                researchIsLoading: state => state.research.isLoading,
                research: state => state.research.data,
                researchError: state => state.research.error,
                reportListIsLoading: state => state.report.isLoading,
                reportList: state => state.report.data,
                reportListError: state => state.report.error,
                reviewListIsLoading: state => state.review.isLoading,
                reviewList: state => state.review.data,
                reviewListError: state => state.review.error
            }),
            mobileDevice () {
                return typeof window === 'object' && window.innerWidth < 768
            },
            tabletDevice () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1025
            },
            desktopSmallDevice () {
                return typeof window === 'object' && window.innerWidth >= 1025 && window.innerWidth < 1200
            },
            desktopDevice () {
                return typeof window === 'object' && window.innerWidth >= 1200
            }
        },
        methods: {
            optionSelected (id) {
                this.dateFrom = ''
                this.dateTo = ''
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=850&include=Y'})
            },

            dateSelected (dateStart, dateEnd) {
                this.dateFrom = dateStart
                this.dateTo = dateEnd
                this.pageParams = `?section=850&date-from=${this.dateFrom}&date-to=${this.dateTo}&include=Y`
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: this.pageParams})
            },

            reportListOptionSelected (id) {
                this.reportListDateFrom = ''
                this.reportListDateTo = ''
                this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: '?section=949'})
            },

            reviewListOptionSelected (id) {
                this.reviewListDateFrom = ''
                this.reviewListDateTo = ''
                this.$store.dispatch(reviewListActionTypes.getReviewList, {apiUrl: this.apiResearch, listFilter: '?path=rent/otchyety/otchyety&include=N&page-size=6'})
            },

            reportListDateSelected (dateStart, dateEnd) {
                this.reportListDateFrom = dateStart
                this.reportListDateTo = dateEnd
                this.pageParams = `?section=949&include=Y&date-from=${this.reportListDateFrom}&date-to=${this.reportListDateTo}`
                this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: this.pageParams})
            },

            reviewListDateSelected (dateStart, dateEnd) {
                this.reviewListDateFrom = dateStart
                this.reviewListDateTo = dateEnd
                this.pageParams = `?path=rent/otchyety/otchyety&include=N&page-size=6&date-from=${this.reviewListDateFrom}&date-to=${this.reviewListDateTo}`
                this.$store.dispatch(reviewListActionTypes.getReviewList, {apiUrl: this.apiResearch, listFilter: this.pageParams})
            },

            onHideMoreContent (elId) {
              if (!elId) return

              scrollToElement(elId)
            }
        },
        mounted() {
            this.$store.dispatch(pressReleaseActionTypes.getPressRelease, {apiUrl: this.apiPressRelease, newsDataFilter: '?category=Интересное по рынку'})
            this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=850&include=Y&page-size=6'})
            this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: '?section=949&page-size=12'})
            this.$store.dispatch(reviewListActionTypes.getReviewList,
                {apiUrl: this.apiResearch, listFilter: '?path=rent/otchyety/otchyety&include=N&page-size=6'}
            ).then(() => {
              this.reviewData.link = {
                title: 'Архив исследований',
                href: this.reviewList.nav?.url?.archive
              }
            })
            headerSearchHandler()
        },

        beforeMount() {
            this.jsonObzorRynka = JSON.parse(document.querySelector('#app').getAttribute('obzor-rynka'))
        }
    }
</script>